import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  toggle: false,
  hideCreateButton: false,
  apInvoice: null,
  apLineItems: [],
  chargeList: [],
  selectedApInvoiceCharge: {},
  apInvoiceID: 0,
  isPostedAlready: false,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  pagination: {
    perPage: 10
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'amount',
      label: 'Amount',
      aria: 'Amount',
      width: '5%',
      numeric: true,
      sortable: true,
      searchable: true
    },
    {
      field: 'glExpenseAccount',
      label: 'G/L Expense',
      width: '45%',
      sortable: true,
      searchable: true
    },
    {
      field: 'description',
      label: 'Description',
      width: '45%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Created',
      date: true,
      width: '5%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
